//src/components/property/PropertyEmptyState.jsx
import React from "react";

const PropertyEmptyState = ({ message = "Properti tidak ditemukan." }) => {
  return (
    <div className="property-empty-state">
      <h3>{message}</h3>
      <p>Coba ubah kata kunci pencarian atau filter properti.</p>
    </div>
  );
};

export default PropertyEmptyState;
